import { useState } from "react";



const HomePage = ({ setActiveTab, setCallbackCheck, data }: any) => {
  const { bookinfo = {} } = data;

  const { title, isbn, postedon, author, coversas } = bookinfo;

  const [isConfirmed, setIsConfirmed] = useState(false);

  return (
    <div className="home-container">
      {/* Header */}
      <p>Dear Author(s),</p>
      <p>From here you can access a copy of {title} as a PDF file.</p>

      {/* Book Details Section */}
      <div className="book-details">
        <div className="book-image">
          <img src={coversas} alt="Book Cover" />
        </div>
        <div className="book-info">

          <table>
            <thead>
            </thead>
            <tbody>

              <tr>
                <td><b>Author:</b></td>
                <td>{author.join(', ')}</td>
              </tr>
              <tr>
                <td><b>Book Title:</b></td>
                <td>{title}</td>
              </tr>
              <tr>
                {/* <td><b>Edition Number:</b></td>
              <td>{bookDataLocal?.edition_number}</td> */}
              </tr>
              <tr>
                <td><b>ISBN:</b></td>
                <td>{isbn}</td>
              </tr>
              <tr>
                <td><b>Date Book Posted:</b></td>
                <td>{postedon}</td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>

      {/* Author Help Section */}
      <div className="author-help">
        <p className="author-help_heading"><b>General Author Help</b></p>
        <p>Visit <a href="http://www.elsevier.com/authors/book-authors" target="_blank" rel="noopener noreferrer">http://www.elsevier.com/authors/book-authors</a></p>
      </div>

      {/* Steps to Access Book */}
      <div className="instructions">
        <p className="highlight">To access your copy of {title}, please follow the steps below:</p>
        <p className="step"><span className="circle-number">1</span> Download and save the PDF file of the Book to your own computer.</p>
      </div>
      {/* Confirmation Checkbox */}
      <div className="confirmation">
        <p>To access your copy:</p>
        <label>
          <input
            type="checkbox"
            checked={isConfirmed}
            onChange={() => { setIsConfirmed(!isConfirmed); setCallbackCheck(!isConfirmed) }}
          />
          I am the author, editor, contributor or reviewer of this Book.
        </label>
      </div>

      {/* Buttons */}
      <div className="buttons">
        {/* <button className="decline" onClick={handleDeclain}>Decline</button> */}
        <button className="confirm" onClick={() => setActiveTab('adobe')} disabled={!isConfirmed}>Confirm and Continue</button>
      </div>
    </div>
  );
};

export default HomePage;
